
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { addProject } from '../../redux/actions/project';

const AddprojectForm = ({dispatch}) => {
    const { addToast } = useToasts();
    const [image, setImage]= useState()
// console.log(image);
    const handleSubmit=(e)=>{
        e.preventDefault();
        const projectname= e.target.project.value;
        // const image= e.target.files.value[0];
        const description= e.target.description.value
        const collectionSize= e.target.collectionsize.value
        const mintPrice= e.target.mintprice.value
        const mintRevenue= e.target.mintrevenue.value
        const teamStatus= e.target.teamstatus.value
        const utilities= e.target.utilities.value
        const website= e.target.website.value
        const twitter= e.target.twitter.value
        const twitterFollowers= e.target.twitterFollowers.value
        const discord= e.target.discord.value
        const discordMember= e.target.discordMember.value
        const megiceden= e.target.magiceden.value
        const oldsummary= e.target.summary.value
        const summary= oldsummary.split(',')

        // const reader = new FileReader();
        // reader.readAsDataURL(image);
        // reader.onloadend = () => {
        //   setImage(reader.result);
        // };

        const formData= new FormData();
        
          formData.append('projectname', projectname)
          formData.append('image', image)
          formData.append('description', description)
          formData.append('collectionSize', collectionSize)
          formData.append('mintPrice', mintPrice)
          formData.append('mintRevenue', mintRevenue)
          formData.append('teamStatus', teamStatus)
          formData.append('utilities', utilities)
          formData.append('website', website)
          formData.append('twitter', twitter)
          formData.append('twitterFollowers', twitterFollowers)
          formData.append('discord', discord)
          formData.append('discordMember', discordMember)
          formData.append('megiceden', megiceden)
          formData.append('summary', summary)
      

dispatch(addProject(formData, addToast)).then(res=>{
    if (res) {
        e.target.reset()
    }
})

    }
    return (
        <section className="author-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">
                            {/* Intro */}
                            <div className="intro text-center">
                                <span>Add new Project</span>
                               
                            </div>
                            {/* Item Form */}
                            <form  className="item-form card no-hover" onSubmit={(e)=>handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="project" placeholder="Project name" required />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="input-group form-group">
                                            <div className="custom-file">
                                                <input type="file" className="custom-file-input" onChange={(e)=>setImage(e.target.files[0])} name="image" id="inputGroupFile01" />
                                                <label className="custom-file-label" htmlFor="inputGroupFile01">Project Image</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <textarea className="form-control" name="description" placeholder="Description" cols={30} rows={3} defaultValue={""} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="collectionsize" placeholder="Collection Size" required="required" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="mintprice" placeholder="Mint Price" required />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="mintrevenue" placeholder="Mint Revenue" required />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <select className="form-select"  required  name='teamstatus'     aria-label="Default select example">
                                                <option disabled value='0'>Team Status</option>
                                                <option value="1">Doxxed</option>
                                                <option value="2">Undoxxed</option>
                                                </select>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <select className="form-select"   required name='utilities'     aria-label="Default select example">
                                                <option disabled value='0'>Utilities</option>
                                                <option value="1">Yes</option>
                                                <option value="2">No</option>
                                                </select>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="website" placeholder="Website" required="required" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="twitter" placeholder="Twitter link" required="required" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="twitterFollowers" placeholder="Twitter Follower"  />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="discord" placeholder="Discord link" required="required" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="discordMember" placeholder="Discord members"  />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="magiceden" placeholder="magic Eden" required="required" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <textarea className="form-control" name="summary" placeholder="Summary (put comma to separate)" cols={30} rows={3} defaultValue={""} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn w-100 mt-3 mt-sm-4" type="submit"><i className="icon-paper-plane mr-2" />Submit</button>
                                    </div>
                                </div>
                            </form>
                            <p className="form-message" />
                        </div>
                    </div>
                </div>
            </section>
    );
};

function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
    //   projectDetails: state.project
    };
  }

export default connect(mapStateToProps)(AddprojectForm);